module.exports = __webpack_public_path__ + "static/media/logo.64ad7638.png";